import {
  buildApplyStageRoutePath,
  useDefineProviderRoute,
} from "@versatile-credit-apply/composition"
import { type RouteRecordRaw } from "vue-router"
import {
  ScreenId,
  type StaticProviderKey,
} from "@versatile-credit-apply/omni-apply-client"

const providerKey: StaticProviderKey = "lendingclub_standard"
const { defineRoute } = useDefineProviderRoute(providerKey)

export const routes: RouteRecordRaw[] = [
  defineRoute({
    path: "/apply/:applyStage/responses/prequalified",
    inherit: true,
    component: () =>
      import("@/providers/lendingclub_standard/views/LendingClubPrequalifiedView.vue"),
    meta: {
      screenId: ScreenId.OFFER_PRESENTATION_PREQUAL,
    },
  }),

  defineRoute({
    path: "/apply/:applyStage/selected",
    component: () =>
      import("@/providers/lendingclub_standard/views/LendingClubOfferSelectedView.vue"),
  }),

  defineRoute({
    path: "/apply/:applyStage/completed",
    component: () =>
      import("@/providers/lendingclub_standard/views/LendingClubCompletedView.vue"),
  }),

  defineRoute({
    path: "/apply/:applyStage/:planCode/review",
    inherit: true,
    redirect: (to) => {
      return buildApplyStageRoutePath(
        to.params.providerKey as string,
        "/selected",
        { params: { ...to.params } }
      )
    },
  }),
]
